
import React, {FC, FormEvent, useState} from 'react';
import classNames from 'classnames';

import ActiveIcon from './svgs/active.inline.svg';
import InactiveIcon from './svgs/inactive.inline.svg';

import * as styles from './styles.module.scss';

type ChatSubmitProps = {
	className?: string
	children: string
	onSubmit: (v: string) => void
}

export const ChatSubmit: FC<ChatSubmitProps> = ({
	className,
	children,
	onSubmit,
}) => {
	const [value, setValue] = useState<string>('');
	const handleSubmit = (e: FormEvent) => {
		e.preventDefault();

		// Pass back to caller & reset
		if (value) {
			onSubmit(value);
			setValue('');
		}
	};

	const clsName = classNames(styles.submit, className);
	return (
		<form className={clsName} onSubmit={handleSubmit}>
			<input
				type='text'
				placeholder={children}
				value={value}
				onChange={(e) => setValue(e.target.value)}
			/>
			{value ? (
				<ActiveIcon onClick={handleSubmit} />
			) : (
				<InactiveIcon onClick={handleSubmit} />
			)}
		</form>
	);
};
